export default "__VITE_ASSET__CTNsNFdC__"